module.exports = __webpack_public_path__ + "static/media/06.7b8efbb8.webp";